// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZfvT","textarea":"styles_textarea__32gq9"};